import { Injectable } from '@angular/core';
import { TokenService } from '@core/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private readonly tokenService: TokenService) {}

  isLogged(): boolean {
    return this.tokenService.isValidToken() || this.tokenService.isValidRefreshToken();
  }
}
